module.exports = __webpack_public_path__ + "img/jobs-salaries.0fe21c67.png";